import React from 'react'
import ReactDOM from 'react-dom'

import App from 'apps/containers/App'
import AppContainer from 'apps/containers/App/AppContainer'

import Routes from 'apps/containers/App/Routes/launcher'

import './styles'

ReactDOM.render(
    <AppContainer>
        <App shouldAttachListener>
            <Routes />
        </App>
    </AppContainer>,
    document.getElementById('apps'),
)
